import {
  enumBoxHeightMode,
  enumBoxStyleSearch,
  enumBoxSubTypes,
  enumBoxType,
  enumBoxWidthMode,
  enumContainerType,
  enumElementBorderStyle,
  enumFillMode,
  enumFlagType,
  enumHierarchyTypes,
  enumObjClassNames,
  enumSubChartFlag,
  enumWrapTextMode,
  kBoxOverlayRule,
  kFieldOverlayRule,
  kPositionBoxOverlayRule,
  kPositionFieldOverlayRule
} from "../constants";
import { inExcludeList } from "../utils/inExcludeList";
import { QBoxLayout } from "./QBoxLayout";
import { QXMLObject } from "./QXMLObject";
import { Globals } from "./Globals";

export class QLayoutMgr extends QXMLObject {
  constructor() {
    super();
    this.fDoc = null;
    this.fLoadList = null; //  new Array();
    this.fLibList = null; // new Array();
  }

  InitLayoutMgr(theDoc) {
    this.fDoc = theDoc;
    this.fOverrideList = [];
    this.SetXMLElementName("layoutmgr");
  }

  GetDoc() {
    return this.fDoc;
  }

  GetSubChartMgr() {
    return this.fDoc.GetSubChartMgr();
  }

  FindLibMatch(aLayout, layoutLib) {
    var n = layoutLib.length;
    for (var i = 0; i < n; i++) {
      var l = layoutLib[i];
      if (aLayout.CompareProperties(l, true, true) == "Match") return l.GetLibID();
    }

    return null;
  }

  OutputLayoutLibJSON() {
    var scm = this.GetSubChartMgr();

    var fullList = scm.GetSCNodeListFiltered(true);
    var n = fullList.length;
    var layoutLib = [];
    var uniqueId = 1;
    var layoutOut = [];
    for (var i = 0; i < n; i++) {
      var node = fullList[i];
      var aLayout = node.GetLayout();
      var boxType = aLayout.GetBoxType();
      if (boxType == enumBoxType.standard) {
        var matchID = this.FindLibMatch(aLayout, layoutLib);
        if (matchID != null) aLayout.SetLibRefID(matchID);
        else {
          var c = aLayout.Clone();
          layoutLib.push(c);
          c.SetLibID(uniqueId);
          layoutOut.push(c.SaveToJSON());
          aLayout.SetLibRefID(uniqueId++);
        }
      }
    }
    return layoutOut;
  }

  OutputLayoutLib(stream) {
    var scm = this.GetSubChartMgr();

    var fullList = scm.GetSCNodeListFiltered(true);
    var n = fullList.length;
    var layoutLib = [];
    var uniqueId = 1;

    for (var i = 0; i < n; i++) {
      var node = fullList[i];
      var aLayout = node.GetLayout();
      var boxType = aLayout.GetBoxType();
      if (boxType == enumBoxType.standard) {
        var matchID = this.FindLibMatch(aLayout, layoutLib);
        if (matchID != null) aLayout.SetLibRefID(matchID);
        else {
          var c = aLayout.Clone();
          layoutLib.push(c);
          c.SetLibID(uniqueId);
          c.OutputToXML(stream);
          aLayout.SetLibRefID(uniqueId++);
        }
      }
    }
  }

  ShowBoxFormatChange(overrideDict) {
    if (!overrideDict?.["overrides"]) return false;

    var hiddenKeys = ["bstyle", "bgroup"];
    var changeKeys = Object.keys(overrideDict["overrides"]) ?? [];
    var visibleChangeKeys = changeKeys.filter(item => !hiddenKeys.includes(item));

    return visibleChangeKeys.length > 0;
  }

  ShowCellFormatChange(overrideDict) {
    if (!overrideDict?.["cellOverrides"]) return false;
    return overrideDict["cellOverrides"].length > 0;
  }

  FlattenOverride(aLayout) {
    var dataObj = aLayout.fDBObjRef;
    if (aLayout.GetSubChartID() === 0 || !dataObj) return;

    const isPosition = dataObj.IsPositionObj();
    var className = dataObj.InferObjectClassName();
    var objID = dataObj.GetObjectRecordID();

    aLayout.SetDBObjID(objID);
    aLayout.SetDBObjClassName(className);

    var overrideObj = { objID: objID, scFlag: aLayout.fSubChartFlag, isPosition };
    overrideObj["scID"] = aLayout.GetSubChartID();

    var overrides = aLayout.fOverrides;
    if (overrides != null && overrides != {}) {
      overrideObj["overrides"] = overrides;
    }
    let cellList = aLayout.fCellList.filter(cell => !cell.IsGutterCell() && cell.HasOverrides());

    let entries = cellList.map(cell => ({
      fFieldID: cell.fFieldID,
      overrides: cell.fOverrides,
      textoverrides: cell.fTextFormat.fOverrides,
      col: cell.fCol,
      row: cell.fRow
    }));

    overrideObj["cellOverrides"] = entries;
    return overrideObj;
  }

  UpdateOverrideInfo(theLayout) {
    let metadata = {
      timestamp: new Date().toUTCString(),
      user: Globals._wsMgr.GetUserName()
    };

    let updatedOverride = this.FlattenOverride(theLayout);
    if (!updatedOverride) return;

    updatedOverride["timestamp"] = metadata["timestamp"];
    updatedOverride["user"] = metadata["user"];

    for (let overrideIdx = 0; overrideIdx < this.fOverrideList.length; overrideIdx++) {
      let overrideObj = this.fOverrideList[overrideIdx];
      if (
        overrideObj["objID"] == updatedOverride["objID"] &&
        overrideObj["scFlag"] == updatedOverride["scFlag"]
      ) {
        if (!theLayout.HasOverrides()) this.fOverrideList.splice(overrideIdx, 1);
        else this.fOverrideList[overrideIdx] = updatedOverride;
        return;
      }
    }
    if (theLayout.HasOverrides())
      //failsafe check
      this.fOverrideList.push(updatedOverride);
  }

  RestoreLayouts(layoutList) {
    var n = layoutList.length;
    for (var i = 0; i < n; i++) {
      var layoutClone = layoutList[i];
      layoutClone.Restore();
      this.UpdateOverrideInfo(layoutClone);
    }
  }

  AddOverride(override) {
    if (!this.fOverrideList.includes(override)) this.fOverrideList.push(override);
  }

  RemoveOverride(override) {
    this.fOverrideList.splice(override, 0);
  }

  OutputToJSON() {
    var layoutObj = {};
    var theDoc = this.GetDoc();
    var backgroundSave = theDoc.GetSaveAsMPTemplate();
    var scm = theDoc.GetSubChartMgr();

    //create library
    layoutObj["layoutLib"] = this.OutputLayoutLibJSON(null);

    var fullList;
    if (backgroundSave) {
      fullList = scm.GetBackgroundNodes();
    } else fullList = scm.GetSCNodeListFiltered(true);

    var n = fullList.length;
    layoutObj["layouts"] = [];
    for (var i = 0; i < n; i++) {
      var node = fullList[i];
      var aLayout = node.GetLayout();
      var objID = node.GetDataObjID();
      var className = aLayout.GetDBObjClassName() ?? enumObjClassNames.box;
      aLayout.SetDBObjID(objID);
      aLayout.SetDBObjClassName(className);
      layoutObj["layouts"].push(aLayout.SaveToJSON());
      aLayout.SetLibRefID(null);
    }

    layoutObj["overrides"] = this.fOverrideList;

    return layoutObj;
  }

  OutputChildElements(stream) {
    var theDoc = this.GetDoc();
    var mpTemplate = theDoc.GetSaveAsMPTemplate();
    var scm = theDoc.GetSubChartMgr();

    this.OutputLayoutLib(stream);

    var fullList;
    if (mpTemplate) {
      fullList = scm.GetBackgroundNodes();
    } else fullList = scm.GetSCNodeListFiltered(true);

    var n = fullList.length;
    var className = enumObjClassNames.box;
    for (var i = 0; i < n; i++) {
      var node = fullList[i];
      var aLayout = node.GetLayout();
      var objID = node.GetDataObjID();
      aLayout.SetDBObjID(objID);
      aLayout.SetDBObjClassName(className);
      aLayout.OutputToXML(stream);
      aLayout.SetLibRefID(null);
    }
  }

  FindSCID(dbObj) {
    var dbObjID = dbObj.GetObjectID();
    var numLayouts = this.fLoadList.length;
    for (var i = 0; i < numLayouts; i++) {
      var l = this.fLoadList[i];
      var objID = l.GetDBObjID();
      if (objID == dbObjID) {
        var scFlag = l.GetSubChartFlag();
        if (scFlag == enumSubChartFlag.nobreak) {
          var scID = l.GetSubChartID();
          return scID;
        }
      }
    }

    return null;
  }

  LoadBoxLayouts(layoutList, fromJSON) {
    //This fxn is a bit fundamentally odd that it combines the library and regular list

    if (!this.fLoadList) this.fLoadList = [];
    if (!this.fLibList) this.fLibList = [];

    var childList = layoutList;
    var numLayouts = childList.length;
    for (var i = 0; i < numLayouts; i++) {
      var layoutInfo = childList[i];
      var aLayout = new QBoxLayout();
      aLayout["layoutMgr"] = this;
      fromJSON ? aLayout.LoadFromJSON(layoutInfo) : aLayout.LoadFromXML(layoutInfo);

      var libID = aLayout.GetLibID();

      if (libID == null) this.fLoadList.push(aLayout);
      else this.fLibList.push(aLayout);

      delete aLayout["layoutMgr"];
    }
  }

  LoadFromJSON(json) {
    this.fLoadList = [];
    this.fLibList = [];
    this.fOverrideList = [];
    var layoutLib = json["layoutLib"];
    this.LoadBoxLayouts(layoutLib, true);

    var layoutList = json["layouts"];
    this.LoadBoxLayouts(layoutList, true);

    var overrides = json["overrides"];
    this.LoadLayoutOverrides(overrides);
  }

  LoadLayoutOverrides(json) {
    var n = json.length;
    for (var i = 0; i < n; i++) {
      var override = json[i];
      this.fOverrideList.push(override);
    }
  }

  LoadChildElements(objTree) {
    this.fLoadList = [];
    this.fLibList = [];
    var childList = objTree.GetChildOfTypeList("boxlayout");
    this.LoadBoxLayouts(childList);
  }

  GetLoadList() {
    return this.fLoadList;
  }

  FindLibLayout(refID) {
    var theLib = this.fLibList;
    var n = theLib.length;
    for (var i = 0; i < n; i++) {
      var e = theLib[i];
      if (e.GetLibID() == refID) return e;
    }

    return null;
  }

  LoadLayouts(excludeList) {
    //Complete process of taking layouts from storage into the FE DB.
    var theDoc = this.GetDoc();
    var objDB = theDoc.GetObjDB();

    var loadList = this.GetLoadList();
    if (loadList == null) {
      //   console.log("9.30.2015 GetLoadList Null");
      return;
    }
    var scm = this.GetSubChartMgr();

    for (var i in loadList) {
      var aLayout = loadList[i];
      var refId = aLayout.GetLibRefID();
      if (refId != null) {
        var libLayout = this.FindLibLayout(refId);
        aLayout = libLayout.CloneLib(aLayout);
        aLayout.SetLibRefID(null);
      }

      var objID = aLayout.GetDBObjID();
      var className = aLayout.GetDBObjClassName();
      var objClass = objDB.GetClassByName(className);
      var dataObj = objClass.RetrieveObject(objID);
      aLayout.SetDBObj(dataObj, objDB);

      this.FinishLoadLayout(aLayout, objDB);

      // Add a scnode for the SubchartMgr to manage...
      if (aLayout.IsValid()) {
        var skipNode = excludeList && inExcludeList(excludeList, objID);
        if (!skipNode) {
          var newNode = scm.AddSCNode(aLayout, dataObj, objID);
          // An autotext element needs a reference to the doc
          aLayout.SetDocRef(theDoc);
        }
      }
    }
    this.ApplyOverrides(excludeList);
    this.fLoadList = null;
    this.fLibList = null;
  }

  ApplyOverrides(overwriteExisting) {
    //Given an existing SCNodeList, apply the current overrides to it.
    //TODO: This could be condensed...and potentially made more performant.
    var scm = this.GetSubChartMgr();
    if (!this.fOverrideList || !scm.fNodeList.length) return;
    var n = this.fOverrideList.length;
    let overridesToPurge = [];

    for (var i = 0; i < n; i++) {
      var theOverride = this.fOverrideList[i];
      var objectID = theOverride["objID"];
      var scFlag = theOverride["scFlag"];

      //TODO: Handle a box going from 1 page to 2 pages and visa versa.
      var subchartID = theOverride["scID"];
      if (objectID == null) {
        console.log("Override appled to box without personID. Should not happen.");
        continue;
      }

      var theSCNodeList = scm.FindSCSubNodesFromRecordID(
        objectID,
        theOverride.isPosition ? enumObjClassNames.position : enumObjClassNames.box
      );
      if (theSCNodeList.length > 1)
        theSCNodeList = theSCNodeList.filter(function (a) {
          return a.GetSubChartFlag() == scFlag ? 1 : 0;
        });

      // Holder boxes will have the same SubChartFlag. Here we ensure the override is applied to the relevant box.
      if (theSCNodeList.length > 1 && scm.fDoc.IsPositionDocument()) {
        const dataObjID = theSCNodeList[0].GetDataObjID();
        if (dataObjID == null) break;

        const allMatchingHolders = !theSCNodeList.some(node => {
          const isPosition = node.IsPositionSCNode();
          const currentNodeDataObjID = node.GetDataObjID();
          return isPosition || currentNodeDataObjID != dataObjID;
        });

        if (!allMatchingHolders) continue;
      } else if (theSCNodeList.length != 1) {
        overridesToPurge.push(theOverride);
        continue;
      }

      theSCNodeList.forEach(theSCNode =>
        this.ApplyOverrideToNode(theSCNode, theOverride, overwriteExisting)
      );
    }

    this.fOverrideList = this.fOverrideList.filter(function (item) {
      return !overridesToPurge.includes(item);
    });
  }

  ApplyOverrideToNode(theSCNode, theOverride, overwriteExisting) {
    const theLayout = theSCNode.GetLayout();

    if (theLayout && (overwriteExisting || !theLayout.HasOverrides())) {
      if (theOverride["overrides"]) theLayout.fOverrides = theOverride["overrides"];
      let cellList = theLayout.fCellList.filter(cell => !cell.IsGutterCell());
      for (let cellOverride in theOverride["cellOverrides"]) {
        let theCellOverride = theOverride["cellOverrides"][cellOverride];
        for (let cell in cellList) {
          let theCell = cellList[cell];
          if (
            theCell.fFieldID &&
            (theCell.fFieldID == theCellOverride["fFieldID"] ||
              (theCellOverride.fFieldID &&
                theCell.fFieldID.replaceAll("^", " ") ==
                  theCellOverride["fFieldID"].replaceAll("^", " ")))
          ) {
            if (theCellOverride["overrides"]) theCell.fOverrides = theCellOverride["overrides"];
            if (theCellOverride["textoverrides"]) {
              theCell.fTextFormat.fOverrides = theCellOverride["textoverrides"];
              theCell.fTextFormat.fFontString = null;
            }
          } else if (
            !theCell.fFieldID &&
            !theCellOverride["fFieldID"] &&
            theCell.fRow == theCellOverride["row"] &&
            theCell.fCol == theCellOverride["col"]
          ) {
            if (theCellOverride["overrides"]) theCell.fOverrides = theCellOverride["overrides"];
            if (theCellOverride["textoverrides"]) {
              theCell.fTextFormat.fOverrides = theCellOverride["textoverrides"];
              theCell.fFontString = null;
            }
          }
        }
      }
    }
  }

  FinishLoadLayout(aLayout, objDB) {
    // Tie layout cells with the underlying database fields

    // need to set layout field ref for tables at this point. save/load are only giving a reference to the fieldname/idv
    aLayout.SetDocRef(this.GetDoc());
    aLayout.HandleLayoutField(objDB);
    var n = aLayout.GetNumCells();
    for (var i = 0; i < n; i++) {
      var cellDesc = aLayout.GetIndexCellDesc(i);
      cellDesc.SetParentLayout(aLayout);
      if (cellDesc.GetFieldSaveName() && !cellDesc.IsFreeText()) {
        var fieldName = cellDesc.GetFieldSaveName();
        var fieldID = cellDesc.GetFieldSaveID();
        if (fieldName != null) {
          var className = cellDesc.GetFieldSaveClassName();
          var objClass = objDB.GetClassByName(className);
          if (objClass == null) {
            cellDesc.SetField(null);
          } else {
            var aField = objClass.GetFieldDefByID(fieldID);
            if (aField == null) aField = objClass.GetFieldDefByName(fieldName);
            if (aField == null) aField = objClass.GetFieldDefByName(fieldName.replaceAll("^", " "));
            cellDesc.SetField(aField);
            if (aField == null) cellDesc.SetFieldInfo(null, null, null);
          }
        }
      }
    }
  }

  GetMRBLayout(containerType) {
    //Hardcoded defaults for MRB. Overridden by actual layouts for the boxes.
    //There is utility in keeping this hardcoded fallback around.
    if (containerType == null) containerType = enumContainerType.standardmrb;

    var kInitialWidth = 164;

    var borderStyle = enumElementBorderStyle.singleBorder;
    var numRows = 0;
    var numCols = 0;
    var theLayout = new QBoxLayout();
    switch (containerType) {
      case enumContainerType.standardmrb:
        numRows = 1;
        numCols = 1;
        break;
      case enumContainerType.comgr:
        borderStyle = enumElementBorderStyle.noBorder;
        numRows = 1;
        numCols = 2;
        break;
    }

    theLayout.InitBoxLayout(kInitialWidth, numRows, numCols);
    theLayout.SetBorderStyle(borderStyle);
    theLayout.SetBoxPadding(4);
    theLayout.SetWidthMax(768);
    theLayout.SetBorderStyle(borderStyle);

    theLayout.SetBoxType(enumBoxType.nonstandard);
    theLayout.SetBoxSubType(enumBoxSubTypes.refMRBox);
    theLayout.SetContainerType(enumContainerType.standardmrb);
    theLayout.SetBoxFillMode(enumFillMode.noFill);
    theLayout.SetDocRef(this.fDoc);

    theLayout.SetWidthSizingMode(enumBoxWidthMode.autoself);
    theLayout.SetHeightSizingMode(enumBoxHeightMode.autoself);

    theLayout.SetContainerTopLinesToColumns(containerType === enumContainerType.comgr);
    theLayout.SetContainerBottomLinesToColumns(containerType === enumContainerType.comgr);
    theLayout.SetContainerInternalLinesToColumns(false);

    theLayout.ClearAssociatedDBObjs();

    //Stop console from having a meltdown
    theLayout.SetPosition(0, 0);

    if (containerType == enumContainerType.standardmrb) {
      const isPositions = this.fDoc.IsPositionDocument();
      const objDB = this.fDoc.GetObjDB();
      const objClassName = isPositions ? "Position" : "Box";
      const objClass = objDB.GetClassByName(objClassName);
      const f1 = objClass.GetTitleFieldDef();
      var c1 = theLayout.GetCellDesc(1, 1);
      c1.SetAlignment("center");
      c1.SetCellHeight(16);
      c1.SetTextBold(true);
      c1.SetCellFillMode(enumFillMode.noFill);
      c1.SetWrapText(enumWrapTextMode.unlimited);
      c1.SetField(f1);
      if (isPositions) {
        theLayout.SetHierarchyType(enumHierarchyTypes.positions);
      }
      //theLayout.CalculateLayout();
    }

    if (containerType == enumContainerType.comgr) {
      var theDoc = this.GetDoc();
      var bsmgr = theDoc.GetDocMgr().fWSMgr.GetBoxStylesMgr();
      theLayout = bsmgr.GetLayoutByID(302, false, enumBoxStyleSearch.allSets);
    }

    return theLayout;
  }

  FindOverride(myPersonID, scid) {
    //TODO: Indexes for this
    var overrides = this.fOverrideList;
    if (!overrides) return null;
    var n = overrides.length;
    for (var i = 0; i < n; i++) {
      var theOverride = overrides[i];
      if (theOverride["ID"] == myPersonID && theOverride["scID"] == scid) {
        //TODO: Splice?
        return theOverride;
      }
    }
    return null;
    //this.ClearOverride(theOverride)
  }

  ConvertOverridesToRuleAction(layout, rule, isPosition = false) {
    let overrides = layout.fOverrides ?? {};
    let cellList = layout.fCellList.filter(
      cell =>
        !cell.IsGutterCell() &&
        (Object.keys(cell.fOverrides ?? {}).length > 0 ||
          Object.keys(cell.fTextFormat.fOverrides).length > 0)
    );

    const action = isPosition ? kPositionBoxOverlayRule : kBoxOverlayRule;
    if (overrides && Object.keys(overrides).length > 0) {
      rule.fActionSet[action] = {};
      if (overrides["boxShapeType"] != null) {
        rule.SetShapeEnabled(true, action);
        rule.SetBoxShapeType(overrides["boxShapeType"], action);
      }
      if (overrides["fillMode"] != null) {
        rule.SetFillEnabled(true, action);
        rule.SetBoxFillMode(overrides["fillMode"], action);
      }
      if (overrides["fillColor"] != null) {
        rule.SetFillEnabled(true, action);
        rule.SetBoxFillColor(overrides["fillColor"], action);
      }
      if (overrides["fillColorGradient"] != null) {
        rule.SetFillEnabled(true, action);
        rule.SetBoxFillColorGradient(overrides["fillColorGradient"], action);
      }
      if (overrides["borderThickness"] != null) {
        rule.SetBorderEnabled(true, action);
        rule.SetBorderThickness(overrides["borderThickness"], action);
      }
      if (overrides["borderStyle"] != null) {
        rule.SetBorderEnabled(true, action);
        rule.SetBorderStyle(overrides["borderStyle"], action);
      }
      if (overrides["dashStyle"] != null) {
        rule.SetBorderEnabled(true, action);
        rule.SetBorderDashStyle(overrides["dashStyle"], action);
      }
      if (overrides["borderColor"] != null) {
        rule.SetBorderColorEnabled(true, action);
        rule.SetBoxBorderColor(overrides["borderColor"], action);
      }
      if (overrides["fFlagType"] != null && overrides["fFlagType"] != enumFlagType.none) {
        rule.SetTriFlagEnabled(true, action);
        rule.SetTriPosition(overrides["fTriPosition"], action);
        rule.SetTriLabel(overrides["fFlagLabel"], action);
        rule.SetTriColor1(overrides["fFlagColor1"], action);
        rule.SetTriColor2(overrides["fFlagColor2"], action);
        rule.SetTriColor3(overrides["fFlagColor3"], action);
      }
    }

    if (cellList && Object.keys(cellList).length > 0) {
      const fieldAction = isPosition ? kPositionFieldOverlayRule : kFieldOverlayRule;
      let entries = cellList.map(cell => ({
        fFieldID: cell.fFieldID,
        overrides: cell.fOverrides ?? {},
        textoverrides: cell.fTextFormat.fOverrides ?? {},
        col: cell.fCol,
        row: cell.fRow
      }));
      for (let entry of entries) {
        if (!entry.fFieldID) continue;
        let hasField = layout.fDBObjRef.GetFieldDefByID(entry.fFieldID);
        if (hasField) {
          if (
            (entry.hasOwnProperty("overrides") && Object.keys(entry.overrides).length > 0) ||
            (entry.hasOwnProperty("textoverrides") && Object.keys(entry.textoverrides).length > 0)
          ) {
            rule.fActionSet[fieldAction] = {};
            if (hasField) rule.SetFieldName(hasField.fFieldName, fieldAction);

            if (entry["overrides"]["fCellFillColor"] != null) {
              rule.SetCellColor(entry["overrides"]["fCellFillColor"], fieldAction);
              rule.SetCellColorEnabled(true, fieldAction);
            }
            if (entry["textoverrides"]["fFontColor"] != null) {
              rule.SetTextColor(entry["textoverrides"]["fFontColor"], fieldAction);
              rule.SetTextColorEnabled(true, fieldAction);
            }
            if (entry["textoverrides"]["fBold"] != null) {
              rule.SetBoldStyle(entry["textoverrides"]["fBold"], fieldAction);
              rule.SetTextStyleEnabled(true, fieldAction);
            }
            if (entry["textoverrides"]["fItalic"] != null) {
              rule.SetItalicStyle(entry["textoverrides"]["fItalic"], fieldAction);
              rule.SetTextStyleEnabled(true, fieldAction);
            }
            if (entry["textoverrides"]["fUnderline"] != null) {
              rule.SetUnderlineStyle(entry["textoverrides"]["fUnderline"], fieldAction);
              rule.SetTextStyleEnabled(true, fieldAction);
            }
            break;
          }
        }
      }
    }
  }
}
